













import { computed, defineComponent, ref } from "@vue/composition-api";
import store from "@/store";
import providers from "@/lib/providers";
import { ACTION_TYPES } from "@/lib/const";
import useLoadingStatus from "@/hooks/useLoadingStatus";
import config from "@/config";
import PageTitle from "@/components/PageTitle.vue";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import { nowDay } from "./hooks/config";
import TotalUsersBlock from "./components/TotalUsersBlock.vue";
import RangeSettings from "./components/RangeSettings";
import RangeChartBlock from "./components/RangeChartBlock";
import { UserGrowthStats } from "./components/TotalUsersBlock.vue";

export default defineComponent({
  name: "Dashboard",
  components: { TotalUsersBlock, BasePageOneColumn, PageTitle, RangeSettings, RangeChartBlock },
  setup() {
    const { loadingStatusShow } = useLoadingStatus();
    const isLoading = ref(false);
    const userRolesStat = ref<Record<string, number>>({});
    const userGrowthStats = ref<UserGrowthStats>({
      prevMonth: 0,
      currentMonth: 0,
    });

    const showStatistics = computed(() => config.featureDashboardStatistics);

    const dates = {
      prevYearDateFrom: new Date(Date.UTC(nowDay().getUTCFullYear() - 1, nowDay().getUTCMonth() + 1)).toISOString(),
      prevMonthDateFrom: new Date(Date.UTC(nowDay().getUTCFullYear(), nowDay().getUTCMonth() - 1)).toISOString(),
      prevMonthDateTo: new Date(
        Date.UTC(nowDay().getUTCFullYear(), nowDay().getUTCMonth() - 1, nowDay().getUTCDate() + 1)
      ).toISOString(),
      currentMonthDateFrom: new Date(Date.UTC(nowDay().getUTCFullYear(), nowDay().getUTCMonth())).toISOString(),
      currentMonthDateTo: new Date(Date.UTC(nowDay().getUTCFullYear(), nowDay().getUTCMonth() + 1)).toISOString(),
    };

    const getUserRolesStat = async () => {
      userRolesStat.value = (await store.dispatch(`stats/roles/${ACTION_TYPES.GET_DATA}`)).info;
    };

    const getUserGrowthStats = async () => {
      await Promise.all([
        providers.RolesProvider.userStatisticSearch({
          data: {
            registrationTimeFrom: dates.prevMonthDateFrom,
            registrationTimeTo: dates.prevMonthDateTo,
          },
        }).then((r: { totalCount: number }) => (userGrowthStats.value.prevMonth = r.totalCount)),
        providers.RolesProvider.userStatisticSearch({
          data: {
            registrationTimeFrom: dates.currentMonthDateFrom,
          },
        }).then((r: { totalCount: number }) => (userGrowthStats.value.currentMonth = r.totalCount)),
      ]);
    };

    const getData = async () => {
      isLoading.value = true;
      loadingStatusShow([
        getUserRolesStat(),
        getUserGrowthStats(),
      ]).finally(() => {
        isLoading.value = false;
      });
    };
    if (showStatistics.value) getData();

    return {
      isLoading,
      userRolesStat,
      showStatistics,
      userGrowthStats,
    };
  },
});
